export default {
  CATEGORY: '商品分类',
  ALL: '全部'
};
